var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_21)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 180,
    width: 491,
    height: 149,
    fill: "#EE1C34"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166,
    y: 13,
    width: 167,
    height: 488,
    fill: "#EE1C34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.333 170.667H341.333V10.667C341.333 4.776 336.558 0 330.667 0H170.667C164.776 0 160 4.776 160 10.667V170.667H10.667C4.776 170.667 0 175.442 0 181.333V330.666C0 336.557 4.776 341.333 10.667 341.333H160V501.333C160 507.224 164.776 512 170.667 512H330.667C336.558 512 341.334 507.224 341.334 501.333V341.333H501.334C507.225 341.333 512.001 336.557 512.001 330.666V181.333C512 175.442 507.224 170.667 501.333 170.667ZM490.667 320H330.667C324.776 320 320 324.776 320 330.667V490.667H181.333V330.667C181.333 324.776 176.557 320 170.666 320H21.333V192H170.666C176.557 192 181.333 187.224 181.333 181.333V21.333H320V181.333C320 187.224 324.776 192 330.667 192H490.667V320Z",
    fill: "#500B28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus-icon.833cff5e2ab3af4cbe36ed1750b9a06f.svg";
export { ForwardRef as ReactComponent };